import { render } from "./ShrinkView.vue?vue&type=template&id=ec796648&scoped=true"
import script from "./ShrinkView.vue?vue&type=script&lang=js"
export * from "./ShrinkView.vue?vue&type=script&lang=js"

import "./ShrinkView.vue?vue&type=style&index=0&id=ec796648&scoped=true&lang=css"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec796648"]])

export default __exports__